import ChatAction from "@/chatbot-library/ChatAction"

class ChatRadios extends ChatAction {
  get name() {
    return "radios"
  }

  getResponseContent(value) {
    let option = this.data.options.find(option => option.id === value)
    return option ? option.label : value
  }
}

export default ChatRadios
